import MagneticDotField from "@/components/magnetic-dot-field";

import { faceReferencePoints as points, faceSecondPoints as secondPoints, faceLandmarkEdges as edges } from "@/lib/face-landmark-artwork";

export function PortraitLandmarks({ variant = "reference" }: { variant?: "reference" | "second" }) {
  const landmarks = variant === "second" ? secondPoints : points;
  return <svg className="conversion-landmarks" viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid slice" fill="none" aria-hidden="true">
    <g className="conversion-landmark-lines">{edges.map(([a,b]) => <line key={`${a}-${b}`} x1={landmarks[a][0]} y1={landmarks[a][1]} x2={landmarks[b][0]} y2={landmarks[b][1]} vectorEffect="non-scaling-stroke" />)}</g>
    <g>{Object.entries(landmarks).map(([name,[cx,cy]]) => <circle key={name} cx={cx} cy={cy} r="4.3" />)}</g>
  </svg>;
}
export function HomeBackdrop() {
  return <MagneticDotField />;
}
